import { PostHogProvider } from '@posthog/react';
import { ReactElement } from 'react';
import { PostHogConfig } from '@/AppSettings';

const options = {
    api_host: PostHogConfig.postHogHost,
    defaults: '2026-05-30',
} as const;

interface TMPostHogProviderProps {
    children: ReactElement;
}

function TMPostHogProvider({ children }: TMPostHogProviderProps) {
    if (PostHogConfig.postHogKey !== null && PostHogConfig.postHogKey !== '') {
        return (
            <PostHogProvider apiKey={PostHogConfig.postHogKey} options={options}>
                {children}
            </PostHogProvider>
        );
    } else {
        return children;
    }
}

export default TMPostHogProvider;
